import cx from 'classnames';
import {useMapLocation} from '~/common/hooks/useMapLocation';
import {Label} from '~/ViewInvitation/common/Label';
import {Typography} from '~library/atoms/Typography';
import './LocationBlock.sass';

export const LocationBlock = ({className = ''}) => {
  const {placeId, meetingUrl, showMap, formatAddress} = useMapLocation();

  return (
    <div className={cx('view-invitation__location-block', className)}>
      <div>
        <Label value="Location" />
        <Typography variant="paragraph1" classNames="view-invitation__details-module__section-body">
          {meetingUrl
            ? <a href={meetingUrl} target="_blank" rel="noreferrer">
                {meetingUrl}
              </a>
            : formatAddress()}
        </Typography>
      </div>
      {placeId && showMap && (
        <iframe
          title="Google Map"
          width="100%"
          height="240"
          loading="lazy"
          allowFullScreen
          className="view-invitation__map"
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps/embed/v1/place?key=${window.mapEmbedApiKey}
    &q=place_id:${placeId}`}
        />
      )}
    </div>
  );
};
